
export default {
  props: {
    deal: {
      type: Object,
      required: true,
    },
    isProductCarousel: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      browse: false,
      avg: false,
      home: false,
    };
  },
  computed: {
    dealReview() {
      if (this.deal.uses_reviews_from_deal) {
        return this.deal.uses_reviews_from_deal.deal_review;
      }

      return this.deal.deal_review;
    },
    tacoRatingPctStyle() {
      // the spaces in between each taco is ~6.5px in length by default,
      // 8px in the product carousel
      const spacing = (this.isProductCarousel) ? 8 : 6.5;
      const percentRating = this.dealReview.percent_rating
        || (this.dealReview.average_rating * 20);
      // each taco is ~15% of the element's width
      // so in actuality 100% should be ~75% filled with tacos, the rest with spaces in between
      const tacoWidth = percentRating * 0.75;
      const spaceWidth = Math.floor(this.dealReview.average_rating) * spacing;

      return { width: `calc(${tacoWidth}% + ${spaceWidth}px)` };
    },
  },
};
